export default "__VITE_ASSET__gXXTOxFM__"